(function () {
  var ESSENTIAL_PROPERTY_PREFIX = '__essential_upsell_';
  var FUNNEL_PROPERTY = '__essential_upsell_funnel_id';
  var RECOMMENDED_SALE_PROPERTY = '_stonylab_recommended_sale';
  var RECOMMENDATION_ID_PROPERTY = '_stonylab_recommendation_id';
  var RECOMMENDATION_PAGE_TYPE_PROPERTY = '_stonylab_recommendation_page_type';
  var RECOMMENDATION_PAGE_PATH_PROPERTY = '_stonylab_recommendation_page_path';
  var RECOMMENDATION_SOURCE_PRODUCT_PROPERTY = '_stonylab_recommendation_source_product_id';
  var originalFetch = window.fetch;

  function normalizePageType(pageType, pathname) {
    if (document.querySelector('cart-drawer.active')) return 'cart';

    var normalized = String(pageType || '').toLowerCase();
    if (normalized === 'index') return 'home';
    if (normalized === 'product') return 'product';
    if (normalized === 'cart') return 'cart';
    if (normalized === 'collection') return 'collection';
    if (normalized === 'search') return 'search';
    if (normalized === 'customers/order') return 'account_order';

    if (pathname === '/') return 'home';
    if (/(^|\/)products\//.test(pathname)) return 'product';
    if (/(^|\/)cart(?:\/|$)/.test(pathname)) return 'cart';
    if (/(^|\/)account\/orders\//.test(pathname)) return 'account_order';
    if (/(^|\/)collections(?:\/|$)/.test(pathname)) return 'collection';
    if (/(^|\/)search(?:\/|$)/.test(pathname)) return 'search';
    return 'other';
  }

  function getRecommendationPageContext() {
    var themeContext = window.stonyLabRecommendationPageContext || {};
    var pathname = window.location.pathname || themeContext.path || '/';
    var pageType = normalizePageType(themeContext.pageType || themeContext.template, pathname);
    return {
      pageType: pageType,
      pagePath: pathname,
      sourceProductId: pageType === 'product' && themeContext.productId
        ? String(themeContext.productId)
        : '',
    };
  }

  function getNoDiscountFunnelIds() {
    var funnelIds = new Set();
    var selectors = ['[upsell-app-discounts-data]', '[upsell-app-data]'];

    document.querySelectorAll(selectors.join(',')).forEach(function (element) {
      selectors.forEach(function (selector) {
        var attributeName = selector.slice(1, -1);
        var value = element.getAttribute(attributeName);
        if (!value) return;

        try {
          var data = JSON.parse(value);
          (data.funnels || []).forEach(function (funnel) {
            if (funnel.id && funnel.upsell && funnel.upsell.discountType === 'NONE') {
              funnelIds.add(String(funnel.id));
            }
          });
        } catch (error) {
          // Ignore app data that is unavailable while the widget is rendering.
        }
      });
    });

    return funnelIds;
  }

  function markRecommendedProperties(properties, pageContext) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) return;

    var hasEssentialProperty = Object.keys(properties).some(function (key) {
      return key.indexOf(ESSENTIAL_PROPERTY_PREFIX) === 0;
    });
    if (!hasEssentialProperty) return;

    properties[RECOMMENDED_SALE_PROPERTY] = 'Essential Upsell';
    if (!properties[RECOMMENDATION_PAGE_TYPE_PROPERTY]) {
      properties[RECOMMENDATION_PAGE_TYPE_PROPERTY] = pageContext.pageType;
    }
    if (!properties[RECOMMENDATION_PAGE_PATH_PROPERTY]) {
      properties[RECOMMENDATION_PAGE_PATH_PROPERTY] = pageContext.pagePath;
    }
    if (properties[FUNNEL_PROPERTY]) {
      properties[RECOMMENDATION_ID_PROPERTY] = String(properties[FUNNEL_PROPERTY]);
    }
    if (pageContext.sourceProductId && !properties[RECOMMENDATION_SOURCE_PRODUCT_PROPERTY]) {
      properties[RECOMMENDATION_SOURCE_PRODUCT_PROPERTY] = pageContext.sourceProductId;
    }
  }

  function stripNoDiscountProperties(properties, funnelIds) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) return;

    var funnelId = properties[FUNNEL_PROPERTY];
    if (!funnelId || !funnelIds.has(String(funnelId))) return;

    Object.keys(properties).forEach(function (key) {
      if (key.indexOf(ESSENTIAL_PROPERTY_PREFIX) === 0) delete properties[key];
    });
  }

  function normalizeJsonBody(body, funnelIds, pageContext) {
    var payload;

    try {
      payload = JSON.parse(body);
    } catch (error) {
      return body;
    }

    if (Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        markRecommendedProperties(item.properties, pageContext);
        stripNoDiscountProperties(item.properties, funnelIds);
      });
    } else {
      markRecommendedProperties(payload.properties, pageContext);
      stripNoDiscountProperties(payload.properties, funnelIds);
    }

    return JSON.stringify(payload);
  }

  function normalizeParameterBody(body, funnelIds, pageContext) {
    var groups = {};

    Array.from(body.entries()).forEach(function (entry) {
      var key = entry[0];
      var value = entry[1];
      var match = key.match(/^properties\[([^\]]+)\]$/)
        || key.match(/^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/);

      if (!match) return;

      var group = match.length === 2 ? 'root' : match[1];
      var propertyName = match.length === 2 ? match[1] : match[2];
      groups[group] = groups[group] || {
        keys: [],
        funnelId: null,
        hasEssentialProperty: false,
        recommendationPageType: '',
        recommendationPagePath: '',
      };
      groups[group].keys.push(key);
      if (propertyName.indexOf(ESSENTIAL_PROPERTY_PREFIX) === 0) {
        groups[group].hasEssentialProperty = true;
      }
      if (propertyName === FUNNEL_PROPERTY) groups[group].funnelId = String(value);
      if (propertyName === RECOMMENDATION_PAGE_TYPE_PROPERTY) {
        groups[group].recommendationPageType = String(value);
      }
      if (propertyName === RECOMMENDATION_PAGE_PATH_PROPERTY) {
        groups[group].recommendationPagePath = String(value);
      }
    });

    Object.keys(groups).forEach(function (group) {
      var properties = groups[group];
      var propertyPrefix = group === 'root' ? 'properties' : 'items[' + group + '][properties]';

      if (properties.hasEssentialProperty) {
        body.set(propertyPrefix + '[' + RECOMMENDED_SALE_PROPERTY + ']', 'Essential Upsell');
        if (!properties.recommendationPageType) {
          body.set(propertyPrefix + '[' + RECOMMENDATION_PAGE_TYPE_PROPERTY + ']', pageContext.pageType);
        }
        if (!properties.recommendationPagePath) {
          body.set(propertyPrefix + '[' + RECOMMENDATION_PAGE_PATH_PROPERTY + ']', pageContext.pagePath);
        }
        if (properties.funnelId) {
          body.set(propertyPrefix + '[' + RECOMMENDATION_ID_PROPERTY + ']', properties.funnelId);
        }
        if (pageContext.sourceProductId) {
          body.set(propertyPrefix + '[' + RECOMMENDATION_SOURCE_PRODUCT_PROPERTY + ']', pageContext.sourceProductId);
        }
      }

      if (!properties.funnelId || !funnelIds.has(properties.funnelId)) return;

      properties.keys.forEach(function (key) {
        var propertyMatch = key.match(/\[([^\]]+)\]$/);
        if (propertyMatch && propertyMatch[1].indexOf(ESSENTIAL_PROPERTY_PREFIX) === 0) {
          body.delete(key);
        }
      });
    });

    return body;
  }

  function normalizeBody(body, funnelIds, pageContext) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      return normalizeParameterBody(body, funnelIds, pageContext);
    }

    return typeof body === 'string' ? normalizeJsonBody(body, funnelIds, pageContext) : body;
  }

  function isCartLineRequest(input) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!url) return false;

    try {
      return /\/cart\/(?:add|change)(?:\.js)?$/.test(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return false;
    }
  }

  window.fetch = function (input, init) {
    if (!isCartLineRequest(input) || !init || !init.body) {
      return originalFetch.apply(this, arguments);
    }

    var funnelIds = getNoDiscountFunnelIds();
    var pageContext = getRecommendationPageContext();
    var normalizedInit = Object.assign({}, init, {
      body: normalizeBody(init.body, funnelIds, pageContext),
    });

    return originalFetch.call(this, input, normalizedInit);
  };
})();
